export enum ActionType {
  CHAT_LOADED = 'CHAT/LOADED',
}

interface ChatLoaded {
  type: ActionType.CHAT_LOADED;
}

export const chatLoaded = (): ChatLoaded => ({ type: ActionType.CHAT_LOADED });
